exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select input{border-radius:0 4px 4px 0 !important}\n", ""]);

// exports
